import React, { useState } from "react";
import CreatableSelect from "react-select/creatable";
import { useNavigate, useParams } from "react-router-dom";
import ChangeOperator from "./ChangeOperator";
export default function AllRechnagePlan({
  handleChangeOperator,
  handleInputChange,
  allOperatorList,
  stylesofStypeNew,
  handleChangeStates,
  states,
  isDataRechargeLoaded,
  allAvailablePlaneOption,
  checkAddReachargeDisable,
  handleChangePlanType,
  setIsNewProductAdded,
  rechargeTable,
  isnewProductAdded,
  editPlans,
  salesDetails,
  onsavePlan,
  checkAddPlanDisable,
}) {
  const [isChangeoperator, setIsChangeoperator] = useState(false)
  const navigate = useNavigate();
const redirectChangeOperator = () =>{
  navigate('/change-operator')
}
  return (
    <div
      class="tab-pane fade"
      id="mobi-grap"
      role="tabpanel"
      aria-labelledby="mobi-grap-tab"
    >
      
      <div class="graphead">
      {
        !isChangeoperator ? <>
        <div class="col-12 col-sm-3  mb-2 float-left ">
          <div className="selct-search-drop">
            <label>Select Operator</label>
            <CreatableSelect
              isClearable
              components={{
                IndicatorsContainer: () => null,
                IndicatorSeparator: () => null,
              }}
              name="categoryCode"
              onChange={handleChangeOperator}
              onInputChange={handleInputChange}
              options={allOperatorList}
              styles={stylesofStypeNew}
            />
          </div>
        </div>

        <div class="col-12 col-sm-3  mb-2 float-left ">
          <div className="selct-search-drop">
            <label>Select Circle</label>
            <CreatableSelect
              isClearable
              components={{
                IndicatorsContainer: () => null,
                IndicatorSeparator: () => null,
              }}
              name="categoryCode"
              onChange={handleChangeStates}
              onInputChange={handleInputChange}
              options={states}
              styles={stylesofStypeNew}
              // value={selectStatewithLabel}
              isDisabled={
                isDataRechargeLoaded ||
                (Array.isArray(states) && states?.length == 0)
              }
            />
          </div>
        </div>
        <div class="col-12 col-sm-3  mb-2 float-left ">
          <div className="selct-search-drop">
            <label>Select Plan Type</label>
            <CreatableSelect
              isClearable
              components={{
                IndicatorsContainer: () => null,
                IndicatorSeparator: () => null,
              }}
              name="categoryCode"
              onChange={handleChangePlanType}
              onInputChange={handleInputChange}
              options={allAvailablePlaneOption}
              styles={stylesofStypeNew}
              isDisabled={
                isDataRechargeLoaded ||
                (Array.isArray(states) && states?.length == 0)
              }
            />
          </div>
        </div>  </> : <ChangeOperator stylesofStypeNew={stylesofStypeNew} setIsChangeoperator={setIsChangeoperator} isChangeoperator={isChangeoperator} />}
        {!isChangeoperator  && <div class="col-12 col-sm-3 mb-2 float-right ">
        <button
            type="button"
            className="btn dbbtn float-right"
            // disabled={checkAddReachargeDisable()}
            onClick={() => setIsChangeoperator(!isChangeoperator)}
          >
          { !isChangeoperator ? 'Change Operator' : 'cancel' }
          </button>
          <button
          style={{marginRight:'8px'}}
            type="button"
            className="btn dbbtn float-right"
            disabled={checkAddReachargeDisable()}
            onClick={() => setIsNewProductAdded(true)}
          >
            Create New Plan
          </button>
          
        </div> }
      </div> 
      
        <div class="txn-list" id="recntxn">
        {isDataRechargeLoaded ? (
          <div class="d-flex justify-content-center">
            <div class="spinner-border" role="status">
              <span class="sr-only">Loading...</span>
            </div>
          </div>
        ) : (
          <>
            {rechargeTable !== undefined &&
            rechargeTable !== null &&
            rechargeTable.length > 0 &&
            !isnewProductAdded ? (
              rechargeTable?.map((data) => {
                return (
                  <div class="txn-item" key={data.id}>
                    <div class="txn-head" id="txnhead1">
                      <div
                        class="collapsed"
                        data-bs-toggle="collapse"
                        data-bs-target="#txn1"
                        aria-expanded="false"
                        aria-controls="txn1"
                      >
                        <div
                          class={`txncard ${
                            !data.custom
                              ? "failed rdbg"
                              : `${
                                  data.type === "MANUAL_DEBIT" ||
                                  data.type === "ADD_LIEN" ||
                                  data.type === "REDUCE_LIEN"
                                    ? "failed rdbg"
                                    : "success grbg"
                                }`
                          }`}
                          
                        >
                          <div class="row">
                            <div class="col-12 col-md-2">
                              <div class="txntxt">
                                <h6>
                                  Price:{" "}
                                  {data?.rs !== undefined &&
                                    data?.rs !== null &&
                                    data?.rs}
                                </h6>
                              </div>
                              <div class="txntxt">
                                <h6>
                                  Validity:{""} {data?.validity}
                                </h6>
                              </div>
                            </div>
                            {/* <div class="col-12 col-sm-5 col-lg-3">
                                  <div class="txntxt">
                                    <h6>Txn ID: {data.requestId}</h6>
                                  </div>
                                </div> */}

                            <div class="col-12 col-md-9">
                              <div class="txntxt">
                                <h6> desc : {data.desc}</h6>
                              </div>
                            </div>
                            {data.custom && (
                              <div class="col-12 col-md-1">
                                <div class="txntxt">
                                  <button
                                    type="button"
                                    className="btn dbbtn"
                                    onClick={() => editPlans(data)}
                                  >
                                    Edit
                                  </button>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            ) : isnewProductAdded ? (
              <>
                {salesDetails()}

                {/* <div  class="col-12 col-sm-7 mt-4"> */}

                <button
                  type="button"
                  className="btn dbbtn mt-4"
                  onClick={onsavePlan}
                  disabled={checkAddPlanDisable()}
                >
                  Submit
                </button>
                <button
                  type="button"
                  className="btn dbbtn mt-4 ml-2"
                  onClick={() => setIsNewProductAdded(false)}
                  // disabled={checkDisable()}
                  style={{ background: "#3e637370" }}
                >
                  clear
                </button>
                {/* </div> */}
              </>
            ) : (
              ""
            )}
          </>
        )}
      </div> 
      
      
      {/* <div class="grapreport">	
          <canvas id="mytxn" width="400" height="180"></canvas>
        </div>    */}
    </div>
  );
}
